import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getUsers } from '../api/users';

export function useUsers(params: { pageNumber?: number; pageSize?: number } = {}) {
  return useQuery({
    queryKey: ['users', params],
    queryFn: () => getUsers(params),
    ...listQueryDefaults,
  });
}
